import { useTranslation } from "react-i18next";
import SortableList, { SortableItem, SortableKnob } from "react-easy-sort";
import { CommonInput, FlexBox, INPUT_TYPES, CommonLabelText } from "@brg/ui";
import { DottedIcon } from "shared/icons/DottedIcon";
import { AddButton, ColumnLabelGroup, ProjectEditGrid, ProjectEditPageGridRowBase } from "../../styles";
import { ProjectAddButton } from "../../ProjectAddButton";
import DeleteIcon from "shared/icons/DeleteIcon";
import ResizedImageEnhanced from "shared/components/ResizedImageEnhanced";
import styled, { createGlobalStyle } from "styled-components";
import { useBookEditor } from "_deziiign/books/pages/BookEdit/providers/bookEditorProvider";
import { useHistory } from "react-router-dom";
import { CreateLinkTo } from "shared/constants/linkTo";
import BookChapterColorField from "./BookChapterColorField";

const Image = styled(ResizedImageEnhanced)`
    width: 75px;
    height: auto;
    object-fit: cover;
    align-self: stretch;
`;

const BottomGroup = styled(FlexBox)`
    flex-direction: column;
    gap: 16px;

    .book-chapters-list {
        display: flex;
        flex-direction: column;
        gap: 16px;
        width: 100%;
        user-select: none;
    }
`;

const DraggedItemStyle = createGlobalStyle`
    .book-chapter-dragged {
        z-index: 10000 !important;
    }
`;

const ListItem = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 16px;
    width: 100%;

    svg {
        flex-shrink: 0;
    }
`;

const DragHandle = styled.div`
    cursor: grab;
    padding: 4px;
    touch-action: none;
`;

const ChapterContent = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 16px;
    flex: 1;
    min-width: 0;
    cursor: pointer;
`;

const BookChaptersField = () => {
    const { t } = useTranslation();
    const history = useHistory();

    const bookEditor = useBookEditor();
    const {
        chapters: data,
        onChapterSort,
        onChapterDelete,
        onSelectChaptersClick,
    } = bookEditor?.chaptersEditor || {};

    const hasChapters = !!data?.length;

    const handleChapterClick = (projectId: string) => {
        history.push(CreateLinkTo.bookProjectEdit(projectId));
    };

    const onSortEnd = (oldIndex: number, newIndex: number) => {
        const projectId = data?.[oldIndex]?.projectId;
        if (!projectId || oldIndex === newIndex) return;
        onChapterSort(projectId, newIndex);
    };

    return (
        <ProjectEditPageGridRowBase direction="column" gy={16} align="flex-start">
            <DraggedItemStyle />
            <ProjectEditGrid>
                <ColumnLabelGroup gap={hasChapters ? 16 : 8}>
                    <CommonLabelText>
                        {t('project_edit.add_playbooks_field')}
                    </CommonLabelText>
                    <BottomGroup>
                        {hasChapters && (
                            <SortableList
                                onSortEnd={onSortEnd}
                                className="book-chapters-list"
                                draggedItemClassName="book-chapter-dragged"
                                lockAxis="y"
                            >
                                {data.map((chapter) => (
                                    <SortableItem key={chapter.projectId}>
                                        <ListItem>
                                            <SortableKnob>
                                                <DragHandle>
                                                    <DottedIcon />
                                                </DragHandle>
                                            </SortableKnob>
                                            <ChapterContent onClick={() => handleChapterClick(chapter.projectId)}>
                                                <Image files={chapter?.titleImages} />
                                                <CommonInput
                                                    type={INPUT_TYPES.text}
                                                    disable
                                                    value={chapter?.title}
                                                    onChange={() => null}
                                                />
                                            </ChapterContent>
                                            <DeleteIcon
                                                fill={'#838382'}
                                                onClick={() => onChapterDelete(chapter?.projectId)}
                                            />
                                        </ListItem>
                                    </SortableItem>
                                ))}
                            </SortableList>
                        )}
                        <AddButton
                            onClick={onSelectChaptersClick}
                            style={{ width: '100% !important', marginLeft: 0, marginTop: 0, marginBottom: 'auto' }}
                            fs
                        >
                            <ProjectAddButton
                                text={hasChapters ? "Добавить главу" : "Выбрать Playbooks"}
                                hideIcon={!hasChapters}
                                isProjectEdit
                                reverse
                            />
                        </AddButton>
                    </BottomGroup>
                </ColumnLabelGroup>
                {hasChapters && <BookChapterColorField />}
            </ProjectEditGrid>
        </ProjectEditPageGridRowBase>
    );
};

export default BookChaptersField;
import { useTranslation } from "react-i18next";
import SortableList, { SortableItem, SortableKnob } from "react-easy-sort";
import { CommonInput, FlexBox, INPUT_TYPES, CommonLabelText } from "@brg/ui";
import { DottedIcon } from "shared/icons/DottedIcon";
import { AddButton, ColumnLabelGroup, ProjectEditGrid, ProjectEditPageGridRowBase } from "../../styles";
import { ProjectAddButton } from "../../ProjectAddButton";
import DeleteIcon from "shared/icons/DeleteIcon";
import ResizedImageEnhanced from "shared/components/ResizedImageEnhanced";
import styled, { createGlobalStyle } from "styled-components";
import { useBookEditor } from "_deziiign/books/pages/BookEdit/providers/bookEditorProvider";
import { useHistory } from "react-router-dom";
import { CreateLinkTo } from "shared/constants/linkTo";
import BookChapterColorField from "./BookChapterColorField";

const Image = styled(ResizedImageEnhanced)`
    width: 75px;
    height: auto;
    object-fit: cover;
    align-self: stretch;
`;

const BottomGroup = styled(FlexBox)`
    flex-direction: column;
    gap: 16px;

    .book-chapters-list {
        display: flex;
        flex-direction: column;
        gap: 16px;
        width: 100%;
        user-select: none;
    }
`;

const DraggedItemStyle = createGlobalStyle`
    .book-chapter-dragged {
        z-index: 10000 !important;
    }
`;

const ListItem = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 16px;
    width: 100%;

    svg {
        flex-shrink: 0;
    }
`;

const DragHandle = styled.div`
    cursor: grab;
    padding: 4px;
    touch-action: none;
`;

const ChapterContent = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 16px;
    flex: 1;
    min-width: 0;
    cursor: pointer;
`;

const BookChaptersField = () => {
    const { t } = useTranslation();
    const history = useHistory();

    const bookEditor = useBookEditor();
    const {
        chapters: data,
        onChapterSort,
        onChapterDelete,
        onSelectChaptersClick,
    } = bookEditor?.chaptersEditor || {};

    const hasChapters = !!data?.length;

    const handleChapterClick = (projectId: string) => {
        history.push(CreateLinkTo.bookProjectEdit(projectId));
    };

    const onSortEnd = (oldIndex: number, newIndex: number) => {
        const projectId = data?.[oldIndex]?.projectId;
        if (!projectId || oldIndex === newIndex) return;
        onChapterSort(projectId, newIndex);
    };

    return (
        <ProjectEditPageGridRowBase direction="column" gy={16} align="flex-start">
            <DraggedItemStyle />
            <ProjectEditGrid>
                <ColumnLabelGroup gap={hasChapters ? 16 : 8}>
                    <CommonLabelText>
                        {t('project_edit.add_playbooks_field')}
                    </CommonLabelText>
                    <BottomGroup>
                        {hasChapters && (
                            <SortableList
                                onSortEnd={onSortEnd}
                                className="book-chapters-list"
                                draggedItemClassName="book-chapter-dragged"
                                lockAxis="y"
                            >
                                {data.map((chapter) => (
                                    <SortableItem key={chapter.projectId}>
                                        <ListItem>
                                            <SortableKnob>
                                                <DragHandle>
                                                    <DottedIcon />
                                                </DragHandle>
                                            </SortableKnob>
                                            <ChapterContent onClick={() => handleChapterClick(chapter.projectId)}>
                                                <Image files={chapter?.titleImages} />
                                                <CommonInput
                                                    type={INPUT_TYPES.text}
                                                    disable
                                                    value={chapter?.title}
                                                    onChange={() => null}
                                                />
                                            </ChapterContent>
                                            <DeleteIcon
                                                fill={'#838382'}
                                                onClick={() => onChapterDelete(chapter?.projectId)}
                                            />
                                        </ListItem>
                                    </SortableItem>
                                ))}
                            </SortableList>
                        )}
                        <AddButton
                            onClick={onSelectChaptersClick}
                            style={{ width: '100% !important', marginLeft: 0, marginTop: 0, marginBottom: 'auto' }}
                            fs
                        >
                            <ProjectAddButton
                                text={hasChapters ? "Добавить главу" : "Выбрать Playbooks"}
                                hideIcon={!hasChapters}
                                isProjectEdit
                                reverse
                            />
                        </AddButton>
                    </BottomGroup>
                </ColumnLabelGroup>
                {hasChapters && <BookChapterColorField />}
            </ProjectEditGrid>
        </ProjectEditPageGridRowBase>
    );
};

export default BookChaptersField;
